// extracted by mini-css-extract-plugin
module.exports = {"container":"_index-container-2mon"};